// echarts store
import { data } from 'jquery'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const state = {
  orderData: {}, // 订单实时走势数据
  profitData: {}, // 各站点收益数据
  customerData: {}, // 客户占比
  statisticsDatas: [], // 数据统计
  mapData: {}, // 地图数据
  pickUpData: {}, // 取件方式数据
  hotGoodsData: {}, // 热销商品
  goodsData: [], // 商品数据
  tatisticsProductDatas: [], // 商品数据统计
  countDatas: [], // 各端用户数量统计
  saleDatas: {}// 销售数据
}

const mutations = {
  SET_ORDER_DATA: (state, orderData) => {
    state.orderData = orderData
  },
  SET_PROFIT_DATA: (state, profitData) => {
    state.profitData = profitData
  },
  SET_CUSTOMER_DATA: (state, customerData) => {
    state.customerData = customerData
  },
  SET_STATISTICS_DATA: (state, statisticsDatas) => {
    state.statisticsDatas = statisticsDatas
  },
  SET_MAP_DATA: (state, mapData) => {
    state.mapData = mapData
  },
  SET_PICKUP_DATA: (state, pickUpData) => {
    state.pickUpData = pickUpData
  },
  SET_HOT_GOODS_DATA: (state, hotGoodsData) => {
    state.hotGoodsData = hotGoodsData
  },
  SET_GOODS_DATA: (state, goodsData) => {
    state.goodsData = goodsData
  },
  SET_TATISTICS_PRODUCT_DATAS: (state, tatisticsProductDatas) => {
    state.tatisticsProductDatas = tatisticsProductDatas
  },
  SET_COUNT_DATAS (state, countDatas) {
    state.countDatas = countDatas
  },
  SET_SALE_DATAS (state, saleDatas) {
    state.saleDatas = saleDatas
  }

}

const actions = {
  // 请求订单实时走势数据
  async getOrderData ({ commit }, params) {
    let xdata = []
    let data1 = []
    let data2 = []
    let res = await Vue.prototype.$http.post('/dataScreen/dataReportChart1', {})
    if (res.data.code == 200) {
      xdata = res.data.data.xList
      data1 = res.data.data.y1List
      data2 = res.data.data.y2List
    }
    let option = {
      title: {
        text: '{a|} 订单实时走势图',
        left: 10,
        textStyle: {
          color: '#0092D5',
          rich: {
            a: {
              // 图片的样式
              height: 12, // 图片高度
              backgroundColor: {
                image: require('@/assets/images/icon_screen/icon_title.png')
              }
            }
          }
        }
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,146,213,0.27)',
        borderColor: '#0092D5',
        textStyle: {
          color: '#FFF'
        }
      },
      legend: {
        left: 'right',
        icon: 'roundRect',
        orient: 'vertical',
        align: 'left',
        textStyle: {
          color: '#FFF'
        },
        data: ['下单量', '退单量']
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },

      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: xdata
      },
      yAxis: {
        type: 'value',
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#5C5F7D'
          }
        }
      },
      series: [
        {
          name: '下单量',
          type: 'line',
          symbolSize: 6, // 设置圆圈的大小为10
          symbol: 'circle', // 将小圆点改成实心 不写symbol默认空心
          lineStyle: {
            color: '#005FB8' // 线的颜色
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 1,
              x2: 0,
              y2: 0,
              colorStops: [
                { offset: 1, color: 'rgba(0, 95, 184, 0.63)' },
                { offset: 0, color: 'rgba(5, 9, 53, 0.4)' }
              ],
              globalCoord: false // 缺省为 false
            }

          },
          // 设置折线颜色
          itemStyle: {
            normal: {
              color: '#005FB8' // 圆心颜色

            }
          },
          data: data1
        },
        {
          name: '退单量',
          type: 'line',
          symbolSize: 6, // 设置圆圈的大小为10
          symbol: 'circle', // 将小圆点改成实心 不写symbol默认空心
          // 设置折线颜色
          lineStyle: {
            color: '#00B0BC' // 线的颜色
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 1,
              x2: 0,
              y2: 0,
              colorStops: [
                { offset: 1, color: 'rgba(0, 176, 188, 0.56)' },
                { offset: 0, color: 'rgba(5, 9, 53, 0.4)' }
              ],
              globalCoord: false // 缺省为 false
            }

          },
          itemStyle: {
            normal: {
              color: '#00B0BC' // 圆心颜色

            }
          },
          data: data2
        }
      ]
    }
    commit('SET_ORDER_DATA', option)
  },
  async getProfitData ({ commit }, params) {
    let xdata = []
    let data1 = []
    let data2 = []
    let res = await Vue.prototype.$http.post('/dataScreen/dataReportChart2', {})
    if (res.data.code == 200) {
      xdata = res.data.data.xList
      data1 = res.data.data.y1List
      data2 = res.data.data.y2List
    }
    let max1 = data1.length > 0 ? Math.max(...data1) : 1000
    let max2 = data2.length > 0 ? Math.max(...data2) : 800
    let min1 = 0
    let min2 = data2.length > 0 ? Math.min(...data2) : 0
    let interval1 = Math.ceil(max1 / 10)
    let interval2 = Math.ceil(max2 / 10)
    let option = {
      title: {
        text: '{a|} 各站点营收情况',
        left: 10,
        textStyle: {
          color: '#0092D5',
          rich: {
            a: {
              // 图片的样式
              height: 12, // 图片高度
              backgroundColor: {
                image: require('@/assets/images/icon_screen/icon_title.png')
              }
            }
          }
        }
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,146,213,0.27)',
        borderColor: '#0092D5',
        textStyle: {
          color: '#FFF'
        },
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },

      legend: {
        left: 'right',
        orient: 'vertical',
        align: 'left',
        textStyle: {
          color: '#FFF'
        },
        data: ['同比增长'],
        icon: 'circle'

      },
      xAxis: [
        {
          type: 'category',
          data: xdata,
          axisPointer: {
            type: 'shadow',
            color: '#5C5F7D'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '元',
          min: min1,
          max: max1,
          interval: interval1,
          axisLabel: {
            formatter: '{value} ',
            color: '#5C5F7D'
          },
          position: 'left', // 确保第一个Y轴在左侧
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#5C5F7D'
            },
            onZero: false // 确保轴线不在零刻度线上

          }
        },
        {
          type: 'value',
          min: min2,
          max: max2,
          interval: interval2,
          position: 'right', // 确保第二个Y轴在右侧
          splitLine: {
            show: false
          },
          axisLine: {
            onZero: false // 确保轴线不在零刻度线上
          },
          axisLabel: {
            formatter: '{value} %',
            color: '#5C5F7D'
          }
        }
      ],
      series: [
        {
          name: '成交额',
          // 象柱形图
          type: 'pictorialBar',
          // 同一系列的柱间距离
          barCategoryGap: '-60%',
          yAxisIndex: 0,
          // 自定义svg 图标 (三角锥形的关键)
          symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
          // 默认样式
          itemStyle: {
            label: {
              show: false
            },
            borderColor: '#206fde',
            borderWidth: 2,
            color: {
              colorStops: [
                {
                  offset: 0.6,
                  color: 'rgba(19, 120, 188, 0.7)'
                },
                {
                  offset: 1,
                  color: 'rgba(0, 34, 70, 1)'
                }
              ]
            }
          },
          // 鼠标滑过样式
          emphasis: {
            label: {
              show: true,
              position: 'top',
              color: '#12DCFF'
            },
            itemStyle: {
              borderColor: '#17cdfa',
              borderWidth: 2,
              color: {
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(0, 34, 70, 1)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(0, 95, 184, 1)'
                  }
                ]
              }
            }
          },
          tooltip: {
            valueFormatter: function (value) {
              return value + ' 元'
            }
          },
          data: data1
        },
        {
          name: '同比增长',
          type: 'line',
          smooth: true, // 是否为平滑曲线
          showSymbol: false,
          yAxisIndex: 1,
          lineStyle: {
            color: 'rgba(0, 176, 188, 1)', // 线的颜色
            width: 1 // 线宽
          },
          itemStyle: {
            normal: {
              color: 'rgba(0, 176, 188, 1)' // 圆心颜色
            }
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 1,
              x2: 0,
              y2: 0,
              colorStops: [
                { offset: 1, color: 'rgba(0, 176, 188, 0.61)' },
                { offset: 0, color: 'rgba(5, 9, 53, 0.32)' }
              ],
              globalCoord: false // 缺省为 false
            }

          },
          tooltip: {
            valueFormatter: function (value) {
              return value + ' %'
            }
          },
          data: data2
        }
      ]
    }
    commit('SET_PROFIT_DATA', option)
  },
  async getCustomerData ({ commit }, params) {
    let data1 = [
      { value: 0, name: '新客户', selected: true },
      { value: 0, name: '老客户' }
    ]
    let res = await Vue.prototype.$http.post('/dataScreen/dataReportChart3', {})
    if (res.data.code == 200) {
      let data = res.data.data
      data1[0].value = data['新客户']
      data1[1].value = data['老客户']
    }
    let option = {
      title: {
        text: '{a|} 客户占比',
        left: 10,
        textStyle: {
          color: '#0092D5',
          rich: {
            a: {
              // 图片的样式
              height: 12, // 图片高度
              backgroundColor: {
                image: require('@/assets/images/icon_screen/icon_title.png')
              }
            }
          }
        }
      },
      tooltip: {
        trigger: 'item',
        backgroundColor: 'rgba(0,146,213,0.27)',
        borderColor: '#0092D5',
        textStyle: {
          color: '#FFF'
        },
        formatter: '{a} <br/>{b} : {c} ({d}%)'
      },

      series: [

        {
          name: '客户占比',
          type: 'pie',
          radius: '60%',

          itemStyle: {

            normal: {

              label: {
                backgroundColor: 'transparent',
                textStyle: {
                  color: '#fff'
                }
              },
              color: function (colors) {
                var colorList = [
                  '#00B2C5',
                  '#006ED6'
                ]

                return colorList[colors.dataIndex]
              }
            }
          },
          selectedMode: 'single',
          selectedOffset: 3,
          data: data1
        }
      ]
    }
    commit('SET_CUSTOMER_DATA', option)
  },
  // 数据统计
  getDataStatistics ({ commit }, params) {
    let series = []
    let titles = ['商品总订单', '人均单价', '今日新增会员', '团长', '供应商']
    let datas = [
      [
        { value: 3300, name: '', itemStyle: { color: '#56CA95' } }, // 实际进度数据
        { value: 1000, name: '', itemStyle: { color: '#797979' } } // 用于填充圆环总的数据-实际数据
      ],
      [
        { value: 1300, name: '', itemStyle: { color: '#FFD966' } }, // 实际进度数据
        { value: 3000, name: '', itemStyle: { color: '#797979' } } // 用于填充圆环总的数据-实际数据
      ],
      [
        { value: 500, name: '', itemStyle: { color: '#6DDCE9' } }, // 实际进度数据
        { value: 1000, name: '', itemStyle: { color: '#797979' } } // 用于填充圆环总的数据-实际数据
      ],
      [
        { value: 600, name: '', itemStyle: { color: '#70AD47' } }, // 实际进度数据
        { value: 1000, name: '', itemStyle: { color: '#797979' } } // 用于填充圆环总的数据-实际数据
      ],
      [
        { value: 3300, name: '', itemStyle: { color: '#2E75B6' } }, // 实际进度数据
        { value: 7000, name: '', itemStyle: { color: '#797979' } } // 用于填充圆环总的数据-实际数据
      ]

    ]
    let item = {
      name: '进度',
      type: 'pie',
      center: ['10%', '50%'],
      radius: ['60%', '70%'], // 设置饼图的内外半径，形成圆环效果
      clockwise: false, // 是否顺时针展示
      startAngle: 90, // 起始角度
      silent: true,
      data: [
        { value: 3300, name: '', itemStyle: { color: '#56CA95' } }, // 实际进度数据
        { value: 1000, name: '', itemStyle: { color: '#797979' } } // 用于填充圆环总的数据-实际数据
      ],
      itemStyle: {
        borderWidth: 2 // 圆环的宽度
      },
      markPoint: {
        data: [
          {
            name: '商城总订单',
            x: '10%',
            y: '90%',
            itemStyle: {
              normal: {
                color: 'none' // 标记点颜色设置为无
              }
            },
            label: {
              normal: {
                show: true,
                formatter: '{b}',
                fontWeight: 'normal',
                textStyle: {
                  fontSize: 8,
                  color: '#FFF'
                }
              }
            }
          }
        ]
      },
      label: {
        // 文字位置

        normal: {
          show: true,
          position: 'center', // 标签位置在中心
          formatter: '{c}', // 中心文字的格式化
          textStyle: {
            fontSize: 10,
            color: '#fff',
            backgroundColor: 'transparent'
          }
        }
      }
    }
    for (let i = 0; i < titles.length; i++) {
      let itemVal = JSON.parse(JSON.stringify(item))
      itemVal.data[0] = datas[i][0]
      itemVal.data[1] = datas[i][1]
      itemVal.center = [i * 20 + 10 + '%', '50%']
      itemVal.markPoint.data[0].name = titles[i]
      itemVal.markPoint.data[0].x = i * 20 + 10 + '%'
      itemVal.markPoint.data[0].y = '90%'
      series.push(itemVal)
    }
    let options = {
      series: series
    }
    commit('SET_STATISTICS_DATA', options)
  },
  // 地图数据
  async getDataMap ({ commit }, params) {
    let dataMap = [
      /* { name: '玄武区', value: [100, 300] },
            { name: '秦淮区', value: [100, 300] },
            { name: '建邺区', value: [100, 300] },
            { name: '鼓楼区', value: [100, 300] },
            { name: '浦口区', value: [100, 300] },
            { name: '栖霞区', value: [100, 300] },
            { name: '雨花台区', value: [100, 300] },
            { name: '江宁区', value: [100, 300] },
            { name: '六合区', value: [100, 300] },
            { name: '溧水区', value: [100, 300] },
            { name: '高淳区', value: [100, 300] } */
    ]
    let scatterData = []
    let res = await Vue.prototype.$http.post('/dataScreen/dataReportChart9', {})
    if (res.data.code == 200) {
      dataMap = res.data.data
      dataMap.forEach(item => {
        item.show = true
      })
    }
    let res2 = await Vue.prototype.$http.post('/dataScreen/dataReportChart10', {})
    if (res2.data.code == 200) {
      scatterData = res2.data.data
      scatterData.forEach(item => {
        item.show = false
      })
    }
    let options = {
      tooltip: {
        trigger: 'item',
        formatter: function (e) {
          const params = e.data
          if (!params.show) {
            return
          }
          return params.name + '<br/>' + '站点总数：' + params.value[0] + '<br/>' + '订单总数：' + params.value[1]
        },
        backgroundColor: 'rgba(0,146,213,0.27)',
        borderColor: '#0092D5',
        textStyle: {
          color: '#FFF'
        }
      },

      geo3D: {
        map: 'Nanjing',
        roam: true,
        itemStyle: {
          color: '#60A6FE', // 地图背景颜色
          borderWidth: 1, // 分界线wdith
          borderColor: '#61CFF8', // 分界线颜色
          opacity: 0.92
        },
        regionHeight: 8, // 地图高度
        zlevel: -10,
        viewControl: {
          distance: 50, // 地图视角 控制初始大小
          alpha: 120, // 倾斜角度
          beta: 0, // 旋转角度
          pan: true,
          autoRotateAfterStill: 3,
          distance: 360,
          minAlpha: 5, // 上下旋转的最小 alpha 值。即视角能旋转到达最上面的角度。[ default: 5 ]
          maxAlpha: 90, // 上下旋转的最大 alpha 值。即视角能旋转到达最下面的角度。[ default: 90 ]
          minBeta: -360, // 左右旋转的最小 beta 值。即视角能旋转到达最左的角度。[ default: -80 ]
          maxBeta: 360, // 左右旋转的最大 beta 值。即视角能旋转到达最右的角度。[ default: 80 ]
          animation: true, // 是否开启动画。[ default: true ]
          animationDurationUpdate: 1000, // 过渡动画的时长。[ default: 1000 ]
          animationEasingUpdate: 'cubicInOut' // 过渡动画的缓动效果。[ default: cubicInOut ]
        },
        label: {
          show: false, // 是否显示名字
          color: '#fff', // 文字颜色
          fontSize: 14 // 文字大小
        },
        emphasis: {
          label: {
            show: true, // 是否显示高亮
            textStyle: {
              color: '#fff' // 高亮文字颜色
            }
          },
          itemStyle: {
            color: '#007EE8', // 地图高亮颜色
            borderWidth: 10, // 分界线wdith
            borderColor: '#6BECF5'// 分界线颜色
          }
        },
        light: {
          main: {
            color: '#fff',
            intensity: 1,
            shadow: true,
            shadowQuality: 'high',
            alpha: 25, //
            beta: 20
          },
          ambient: {
            color: '#fff',
            intensity: 0.6
          }
        }
      },
      series: [

        {

          type: 'map3D',
          name: '地图',
          selectedMode: 'single', // 地图高亮单选
          regionHeight: 0, // 地图高度
          map: 'Nanjing',
          zlevel: -9,
          viewControl: {
            distance: 50, // 地图视角 控制初始大小
            alpha: 120, // 倾斜角度
            beta: 0, // 旋转角度
            pan: true,
            autoRotateAfterStill: 3,
            distance: 360,
            minAlpha: 5, // 上下旋转的最小 alpha 值。即视角能旋转到达最上面的角度。[ default: 5 ]
            maxAlpha: 90, // 上下旋转的最大 alpha 值。即视角能旋转到达最下面的角度。[ default: 90 ]
            minBeta: -360, // 左右旋转的最小 beta 值。即视角能旋转到达最左的角度。[ default: -80 ]
            maxBeta: 360, // 左右旋转的最大 beta 值。即视角能旋转到达最右的角度。[ default: 80 ]
            animation: true, // 是否开启动画。[ default: true ]
            animationDurationUpdate: 1000, // 过渡动画的时长。[ default: 1000 ]
            animationEasingUpdate: 'cubicInOut' // 过渡动画的缓动效果。[ default: cubicInOut ]
          },

          label: {
            show: false, // 是否显示名字
            color: '#fff', // 文字颜色
            fontSize: 14 // 文字大小
          },
          itemStyle: {
            color: '#60A6FE', // 地图背景颜色
            borderWidth: 1, // 分界线wdith
            borderColor: '#61CFF8', // 分界线颜色
            opacity: 0.92
          },
          emphasis: {
            label: {
              show: true, // 是否显示高亮
              textStyle: {
                color: '#fff' // 高亮文字颜色
              }
            },
            itemStyle: {
              color: '#007EE8', // 地图高亮颜色
              borderWidth: 10, // 分界线wdith
              borderColor: '#6BECF5'// 分界线颜色
            }
          },
          light: {
            main: {
              color: '#fff',
              intensity: 1,
              shadow: true,
              shadowQuality: 'high',
              alpha: 25, //
              beta: 20
            },
            ambient: {
              color: '#fff',
              intensity: 0.6
            }
          },
          data: dataMap,
          // 自定义名称映射
          nameMap: {
            'Xuanwu': '玄武区',
            'Qinhuai': '秦淮区',
            'Jianye': '建邺区',
            'Gulou': '鼓楼区',
            'Pukou': '浦口区',
            'Qixia': '栖霞区',
            'Yuhuatai': '雨花台区',
            'Jiangning': '江宁区',
            'Luhe': '六合区',
            'Lishui': '溧水区',
            'Gaochun': '高淳区'
          }

        },

        {
          name: '站点分布',
          type: 'scatter3D',
          coordinateSystem: 'geo3D',
          data: scatterData,
          symbolSize: function (val) {
            return 20
          },
          symbol: 'path://M165.184 64A37.44 37.44 0 0 0 128 101.632v828.032c0 20.8 16.64 37.632 37.184 37.632 20.544 0 37.248-16.832 37.248-37.632V101.632A37.504 37.504 0 0 0 165.12 64z m563.584 77.248c-66.624 0-126.4-16.256-167.232-38.656C520.704 80.128 460.928 64 394.304 64c-66.56 0-126.336 27.712-167.232 50.176v424.64c40.832-22.464 100.608-50.176 167.232-50.176s126.4 16.256 167.232 38.592c40.832 22.528 100.608 38.656 167.232 38.656S855.104 536.128 896 513.792V88.96c-40.96 22.464-100.672 52.224-167.232 52.224z',
          itemStyle: {
            color: '#FF0000'
          },
          encode: {
            value: 2
          },
          label: {
            show: false,
            formatter: '{b}',
            position: 'right',
            show: false,
            color: '#FFF'

          },
          emphasis: {
            label: {
              show: true
            }
          }
        }
      ]
    }

    commit('SET_MAP_DATA', options)
  },
  async getPickUpData ({ commit }) {
    let data1 = []
    let res = await Vue.prototype.$http.post('/dataScreen/dataReportChart6', {})
    if (res.data.code == 200) {
      let data = res.data.data
      data.forEach((item) => {
        let e = {
          value: item.typeCount,
          name: item.typeName,
          selected: true
        }
        data1.push(e)
      })
    }
    let options = {
      title: {
        text: '{a|} 取货占比方式',
        left: 10,
        textStyle: {
          color: '#0092D5',
          rich: {
            a: {
              // 图片的样式
              height: 12, // 图片高度
              backgroundColor: {
                image: require('@/assets/images/icon_screen/icon_title.png')
              }
            }
          }
        }
      },
      legend: {
        right: 10,
        top: 10,
        icon: 'roundRect',
        orient: 'vertical',
        align: 'left',
        textStyle: {
          color: '#FFF'
        }
      },

      series: [
        {
          name: '取货占比方式',
          type: 'pie',
          radius: [40, 90],
          center: ['40%', '50%'],
          itemStyle: {
            normal: {

              borderWidth: 1,
              label: {
                backgroundColor: 'transparent',
                textStyle: {
                  color: '#fff'
                }
              },
              color: function (colors) {
                var colorList = [
                  '#00CAD8',
                  '#E6600A',
                  '#8979EB',
                  '#0084FF'
                ]
                return colorList[colors.dataIndex]
              }
            }
          },
          label: {
            normal: {
              show: true,
              position: 'outside',
              formatter: function (params) {
                var percent = (params.percent || 0).toFixed(2)
                return '{d|' + percent + '%}' + '\n{b|' + params.name + '}'
              },
              rich: {
                d: {
                  color: '#0092D5',
                  align: 'center',
                  fontSize: 20
                },
                b: {
                  color: '#fff',
                  align: 'center',
                  fontSize: 14,
                  lineHeight: 20
                }

              }
            }
          },
          selectedMode: 'multiple',
          selectedOffset: 2,
          data: data1
        }
      ]
    }
    commit('SET_PICKUP_DATA', options)
  },
  async getGoodsData ({ commit }, params) {
    let xdata = []
    let data1 = []
    let data2 = []
    let res = await Vue.prototype.$http.post('/dataScreen/dataReportChart4', {})
    if (res.data.code == 200) {
      xdata = res.data.data.xList
      data1 = res.data.data.y1List
      data2 = res.data.data.y2List
    }
    let total1 = data1.reduce((a, b) => Number(a) + Number(b), 0).toFixed(2)
    let total2 = data2.reduce((a, b) => Number(a) + Number(b), 0)
    let totalAmounts = {
      '成交额': total1,
      '销售单量': total2
    }
    let max1 = data1.length > 0 ? Math.max(...data1) : 1000
    let max2 = data2.length > 0 ? Math.max(...data2) : 800
    let interval1 = Math.ceil(max1 / 10)
    let interval2 = Math.ceil(max2 / 10)
    let options = {
      title: {
        text: '{a|} 商品品类出售情况',
        left: 10,
        textStyle: {
          color: '#0092D5',
          rich: {
            a: {
              // 图片的样式
              height: 12, // 图片高度
              backgroundColor: {
                image: require('@/assets/images/icon_screen/icon_title.png')
              }
            }
          }
        }
      },
      legend: {
        right: 10,
        top: 0,
        icon: 'roundRect',
        orient: 'vertical',
        align: 'left',
        textStyle: {
          color: '#FFF',
          fontSize: 10
        },
        formatter: function (name) {
          const total = totalAmounts[name]
          return `${name} (${total})`
        }
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,146,213,0.27)',
        borderColor: '#0092D5',
        textStyle: {
          color: '#FFF'
        }
      },
      grid: {
        left: '0%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: xdata,
        axisLabel: {
          interval: 0,
          color: '#5C5F7D'
        },
        axisTick: {
          alignWithLabel: true
        }
      },
      yAxis:
                [
                  {
                    type: 'value',
                    name: '元',
                    min: 0,
                    max: max1,
                    interval: interval1,
                    axisLabel: {
                      formatter: '{value} ',
                      color: '#5C5F7D'
                    },
                    splitLine: {
                      lineStyle: {
                        type: 'dashed',
                        color: '#5C5F7D'
                      }
                    }
                  },
                  {
                    type: 'value',
                    min: 0,
                    max: max2,
                    interval: interval2,
                    splitLine: {
                      show: false
                    },
                    axisLabel: {
                      formatter: '{value} 单',
                      color: '#5C5F7D'
                    }
                  }
                ],

      series: [
        {
          name: '成交额',
          data: data1,
          type: 'bar',
          yAxisIndex: 0,
          itemStyle: {
            normal: {
              color: {
                type: 'linear',
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  { offset: 1, color: 'rgba(0, 176, 188, 1)' },
                  { offset: 0, color: 'rgba(0, 176, 188, 0)' }
                ],
                globalCoord: false // 缺省为 false
              },
              borderRadius: [50, 50, 0, 0]
            }
          }

        },
        {
          name: '销售单量',
          data: data2,
          type: 'bar',
          yAxisIndex: 1,
          itemStyle: {
            normal: {
              color: {
                type: 'linear',
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  { offset: 1, color: 'rgba(0, 95, 184, 1)' },
                  { offset: 0, color: 'rgba(1, 93, 181, 0)' }
                ],
                globalCoord: false // 缺省为 false
              },
              borderRadius: [50, 50, 0, 0]
            }
          }

        }]
    }
    commit('SET_GOODS_DATA', options)
  },
  async getHotGoodsData ({ commit }, params) {
    let xdata = []
    let data2 = []
    let res = await Vue.prototype.$http.post('/dataScreen/dataReportChart5', {})
    if (res.data.code == 200) {
      xdata = res.data.data.xList
      data2 = res.data.data.y2List
    }
    let options = {
      title: {
        text: '{a|} 爆品销售商品',
        left: 10,
        textStyle: {
          color: '#0092D5',
          rich: {
            a: {
              // 图片的样式
              height: 12, // 图片高度
              backgroundColor: {
                image: require('@/assets/images/icon_screen/icon_title.png')
              }
            }
          }
        }
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,146,213,0.27)',
        borderColor: '#0092D5',
        textStyle: {
          color: '#FFF'
        }
      },
      grid: {
        left: '0%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: xdata,
        axisLabel: {
          interval: 0,
          color: '#5C5F7D'
        }
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          color: '#5C5F7D'
        },
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#5C5F7D'
          }
        }
      },
      series: [
        {
          name: '销售单量',
          data: data2,
          type: 'bar',
          itemStyle: {
            normal: {
              color: {
                type: 'linear',
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  { offset: 1, color: 'rgba(0, 184, 255, 1)' },
                  { offset: 0, color: 'rgba(0, 102, 198, 0.62)' }
                ],
                globalCoord: false // 缺省为 false
              },
              borderRadius: [50, 50, 0, 0]
            }
          }

        }

      ]
    }
    commit('SET_HOT_GOODS_DATA', options)
  },
  getTatisticsProductDatas ({ commit }, params) {
    let series = []
    let titles = ['商品上架数', '被访问数', '商品曝光量', '商品访客量', '商品访问量']
    let datas = [

      { value: '0.44', name: '', itemStyle: { color: '#FA8024' }, center: ['18%', '20%'], mCenter: ['18%', '52%'] },
      { value: '0.44', name: '', itemStyle: { color: '#885EFB' }, center: ['49%', '20%'], mCenter: ['49%', '52%'] },
      { value: '0.44', name: '', itemStyle: { color: '#00D6D6' }, center: ['80%', '20%'], mCenter: ['80%', '52%'] },
      { value: '0.44', name: '', itemStyle: { color: '#DA4767' }, center: ['32%', '70%'], mCenter: ['32%', '102%'] },
      { value: '0.44', name: '', itemStyle: { color: '#ED6E68' }, center: ['64%', '70%'], mCenter: ['64%', '102%'] }
    ]
    let item = {
      name: '被访问数',
      type: 'liquidFill',
      radius: '36%',
      center: ['49%', '20%'],
      backgroundStyle: {
        color: 'transparent'
      },
      label: {
        color: '#FFF',
        fontSize: 14,
        fontWeight: 'normal',
        formatter: function (params) {
          let value = (params.value * 100).toFixed(2) + '%'
          return value + '\n \n' + '昨日20'
        }
      },
      markPoint: {
        data: [
          {
            name: '被访问数',
            x: '49%',
            y: '54%',
            itemStyle: {
              normal: {
                color: 'none' // 标记点颜色设置为无
              }
            },
            label: {
              normal: {
                show: true,
                formatter: '{b}',

                textStyle: {
                  fontSize: 14,
                  color: '#FFF'
                }
              }
            }
          }
        ]
      },
      itemStyle: {
        color: '#885EFB',
        shadowColor: 'rgba(0, 0, 0, 0)'
      },
      outline: {
        show: true,
        borderDistance: 5,
        itemStyle: {
          borderColor: '#885EFB',
          backgroundColor: '#885EFB',
          borderStyle: 'dashed',
          borderWidth: 2
        }
      },
      data: ['0.33']
    }
    for (let i = 0; i < titles.length; i++) {
      let itemVal = JSON.parse(JSON.stringify(item))
      itemVal.name = titles[i]
      itemVal.data = [datas[i].value]
      itemVal.center = datas[i].center
      itemVal.markPoint.data[0].name = titles[i]
      itemVal.markPoint.data[0].x = datas[i].mCenter[0]
      itemVal.markPoint.data[0].y = datas[i].mCenter[1]
      itemVal.itemStyle.color = datas[i].itemStyle.color
      itemVal.outline.itemStyle.borderColor = datas[i].itemStyle.color
      itemVal.outline.itemStyle.backgroundColor = datas[i].itemStyle.color
      itemVal.label.formatter = function (params) {
        let value = (params.value * 100).toFixed(2) + '%'
        return value + '\n \n' + datas[i].name
      }

      series.push(itemVal)
    }
    let options = {
      series: series
    }
    commit('SET_TATISTICS_PRODUCT_DATAS', options)
  },
  async getCountData ({ commit }, params) {
    let res = await Vue.prototype.$http.post('/dataScreen/dataReportChart7', {})
    if (res.data.code == 200) {
      commit('SET_COUNT_DATAS', res.data.data)
    }
  },
  // 销售统计数据
  async getSalesData ({ commit }, params) {
    let res = await Vue.prototype.$http.post('/dataScreen/dataReportChart8', {})
    if (res.data.code == 200) {
      commit('SET_SALE_DATAS', res.data.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
